import { hasScreenShare, useParticipantViewContext } from '@stream-io/video-react-sdk';
import { VideoPlaceholder } from './video-placeholder';
import { useTranslation } from 'react-i18next';

export const CustomParticipantViewUIOthers = () => {
  const { participant } = useParticipantViewContext();

  if (participant.videoDimension == null && !hasScreenShare(participant))
    return (
      <div className="z-99999 w-full h-full">
        <VideoPlaceholder size="large" />
      </div>
    );

  return (
    <div className="absolute top-0 left-0 transparent">
      <h1 className="p-2 lg:p-4 bg-black/50 rounded-tl-xl rounded-br-lg lg:text-2xl text-white [text-shadow:0_1px_0_rgb(0_0_0/40%)] font-bold">
        {participant.name}
      </h1>
    </div>
  );
};

export const CustomParticipantViewUIMyself = () => {
  const { t } = useTranslation();

  return (
    <div className="absolute top-0 left-0">
      <h1 className="p-2 bg-black/50 rounded-tl-xl rounded-br-lg text-white [text-shadow:0_1px_0_rgb(0_0_0/40%)] font-bold">
        {t('video_call.myParticipantViewLabel')}
      </h1>
    </div>
  );
};
